import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AppLangCode, ThemeMode } from '@libs/types';
import { getJurisdictionBaseUrl } from '@libs/helpers';
import { JurisdictionsEnum } from '@libs/backend-common';
export const useLanguageAndThemeFromURL = (changeLanguage, selectTheme) => {
    const [searchParams, setSearchParams] = useSearchParams();
    useEffect(() => {
        const urlLanguage = searchParams.get('selectedLangCode') || null;
        const urlTheme = searchParams.get('selectedTheme') || null;
        searchParams.delete('selectedTheme');
        searchParams.delete('selectedLangCode');
        const { jurisdictionId } = getJurisdictionBaseUrl();
        if (urlLanguage && Object.values(AppLangCode).includes(urlLanguage)) {
            changeLanguage(urlLanguage);
        }
        if (urlTheme &&
            Object.values(ThemeMode).includes(urlTheme) &&
            jurisdictionId !== JurisdictionsEnum.GE) {
            selectTheme(urlTheme);
        }
        setSearchParams(searchParams);
        changeLanguage(urlLanguage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
//# sourceMappingURL=useLanguageAndThemeFromURL.js.map